<template>
  <section class="opponent-found">
    <div class="opponent-found__vs"><span>{{ getTranslations.home_opponent_found_vs }}</span></div>
    <div class="opponent-found__item opponent-found__item--left">
      <img :src="playersDetails.homePlayerAvatar" alt="" class="opponent-found__item__avatar">
      <span class="opponent-found__item__name">{{ playersDetails.homePlayerUsername }}</span>
      <span class="opponent-found__item__level">{{ getTranslations.home_opponent_found_level }} {{ playersDetails.homePlayerLevel }}</span>
    </div>
    <div class="opponent-found__item opponent-found__item--right">
      <img :src="playersDetails.awayPlayerAvatar" alt="" class="opponent-found__item__avatar">
      <span class="opponent-found__item__name">{{ playersDetails.awayPlayerUsername }}</span>
      <span class="opponent-found__item__level">{{ getTranslations.home_opponent_found_level }} {{ playersDetails.awayPlayerLevel }}</span>
    </div>
  </section>
</template>

<script>
/* eslint no-console: "off", no-use-before-define: ["error", { "variables": false }] */
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
import webSocket from '@/common/webSocket';
import auth from '@/common/auth';
import { opponentFoundVSText } from '@/common/jQuery';
import { ParseResponseMixin, GameMixin2, GameMixin3 } from '@/common/mixins/game';

export default {
  name: 'opponent-found',
  mixins: [ParseResponseMixin, GameMixin2, GameMixin3],
  data() {
    return {
      connectionTimer: null,
      stompClient: null,
      subscription: null,
    };
  },
  created() {
    // console.clear();
    this.stompClient = webSocket.getGameStompClient();
    if (this.stompClient === null) {
      this.stompClient = webSocket.createNewStompClient('/gameData');
    }
    console.log('this.stompClient:', this.stompClient);
    this.getThemesForGame();
  },
  beforeDestroy() {
    this.subscribeUserForOnlineChannelAndThenOpenTheChannel({ statusOnline: true });
  },
  mounted() {
    console.log('in OpponentFound mounted hook');
    console.log('this.playersDetails:', this.playersDetails);
    opponentFoundVSText();
  },
  methods: {
    ...mapActions('profile', [
      'subscribeUserForOnlineChannelAndThenOpenTheChannel',
    ]),
    ...mapMutations('game', [
      'setPlayersCurrentThemes',
    ]),
    getThemesForGame() {
      const stompSuccess = (frame) => {
        clearTimeout(this.connectionTimer);
        console.log(`In SearchingOpponent component: ${frame}`);
        console.log(`Subscribing to channel: /topic/categoriesFetched/${this.gameID}`);
        this.subscription = this.stompClient.subscribe(`/topic/categoriesFetched/${this.gameID}`, (response) => {
          this.subscription.unsubscribe();
          console.log('[OpponentFound] Inside categoriesFetched response');
          // parse server response and return if any errors occur
          const responseData = this.parseServerResponse(response.body);
          if (responseData === null) {
            return;
          }
          console.log('responseData:', responseData);
          if (responseData.gameStateEnum === 'CATEGORIES_FETCHED') {
            this.subscribeUserForOnlineChannelAndThenOpenTheChannel({ statusOnline: false });
            console.log('gameStateEnum: CATEGORIES_FETCHED');
            this.setPlayersCurrentThemes({
              homePlayerCurrentThemes: responseData.homeUserDetails.themeDTOList,
              awayPlayerCurrentThemes: responseData.awayUserDetails.themeDTOList,
            });
            this.normalTransition = true;
            console.log('going to selectTheme');
            this.$router.replace('/selectTheme');
          }
        }, (errorResponse) => {
          console.error(`Error response: ${errorResponse}`);
        });
      };

      const stompFailure = (error) => {
        console.error(`Connect failed with the following error: ${error.headers.message}`);
        console.log(this.$router.currentRoute);
        if (this.$router.currentRoute.path === '/searchingOpponent') {
          console.info('Lost connection to WebSocket! Reconnecting in 3 seconds...');
          clearTimeout(this.connectionTimer);
          this.connectionTimer = setTimeout(() => {
            this.stompClient = webSocket.createNewStompClient('/gameData');
            connect();
          }, 3000);
        }
      };

      const connect = (() => {
        if (!this.stompClient.connected) {
          this.stompClient.connect({ Authorization: auth.getJwt() }, stompSuccess, stompFailure);
        } else {
          stompSuccess();
        }
      })();
    },
  },
  computed: {
    ...mapState('game', [
      'gameID',
      'playersDetails',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/game/OpponentFound.vue